export function faq() {

  // Change the close icon
  $('[data-featherlight]').featherlight('', {
    closeIcon: "<span class='svg js-svg-fallback icon-icon_x' data-filename='icon_x'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\"><path fill=\"#292929\" fill-rule=\"evenodd\" d=\"M25.352 2.272L23.483.404 12.852 11.035 2.22.404.352 2.272l10.631 10.632L.352 23.535l1.868 1.869 10.632-10.632 10.631 10.632 1.869-1.869L14.72 12.904z\"/></svg></span>"
  });

  // Category filtering
  let $catFilter = $('.js-faq-category-select');
  let $faqItems = $('.js-faq-item');

  $catFilter.on('change', function(e){
    let selectedCat = this.value;
    let filterOn = '[data-categories~="' + selectedCat + '"]';

    // If show all or select a category...
    if (!selectedCat || selectedCat === "all" || selectedCat === "") {
      $faqItems.fadeIn();
    } else {

      // otherwise
      $faqItems.not(filterOn).fadeOut(200, function(){
        $faqItems.filter(filterOn).fadeIn(200);
      });

    }
  });

}



// WEBPACK FOOTER //
// ./resources/js/utils/faq.js